/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SamText } from './SamText'
import { Quantity } from './Quantity'
import { RouteOfAdministration } from './RouteOfAdministration'
import { Indication } from './Indication'
import { BoundedParameter } from './BoundedParameter'

export class StandardDosage {
  constructor(json: JSON | any) {
    Object.assign(this as StandardDosage, json)
  }

  code?: number
  targetGroup?: string
  kidneyFailureClass?: number
  liverFailureClass?: number
  treatmentDurationType?: string
  temporalityDuration?: Quantity
  temporalityUserProvided?: Boolean
  temporalityNote?: SamText
  quantity?: number
  quantityDenominator?: number
  quantityMultiplicator?: string
  quantityRangeLower?: number
  quantityRangeLowerDenominator?: number
  quantityRangeUpper?: number
  quantityRangeUpperDenominator?: number
  administrationFrequencyQuantity?: number
  administrationFrequencyIsMax?: Boolean
  administrationFrequencyTimeframe?: Quantity
  maximumAdministrationQuantity?: number
  maximumAdministrationQuantityDenominator?: number
  maximumAdministrationQuantityMultiplicator?: string
  maximumDailyQuantity?: number
  maximumDailyQuantityDenominator?: number
  maximumDailyQuantityMultiplicator?: string
  textualDosage?: SamText
  supplementaryInfo?: SamText
  routeSpecification?: SamText
  indication?: Array<Indication>
  parameterBounds?: Array<BoundedParameter>
  routeOfAdministration?: RouteOfAdministration
}
